import { render, staticRenderFns } from "./ChatOrderProduct.vue?vue&type=template&id=add810c4&scoped=true&"
import script from "./ChatOrderProduct.vue?vue&type=script&lang=js&"
export * from "./ChatOrderProduct.vue?vue&type=script&lang=js&"
import style0 from "./ChatOrderProduct.vue?vue&type=style&index=0&id=add810c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add810c4",
  null
  
)

export default component.exports